import { useEffect, useRef, useState } from "react"

import heartExplosionLottie from '@assets/images/heart-explosion.lottie'
import { DotLottieReact, setWasmUrl } from "@lottiefiles/dotlottie-react"
import { size } from "@styles/theme"
import styled from "@emotion/styled"

import { PiHeartBold, PiHeartFill } from "react-icons/pi"

const HeartContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

const LottieContainer = styled.div`
  position: absolute;
`

// NOTE: We're setting the WASM URL explicitly because it's the exact same file we're preloading in the public/index.html file.
//       We're preloading it in the index.html file to prevent dotlottie-react from loading it on the first run of the heart animation
//.      causing the animation to fail/stagger because the WASM player won't load fast enough. 
setWasmUrl('https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@0.39.0/dist/dotlottie-player.wasm')

const Heart = ({ likeCount, currentUserLiked, heartSize=2.1 }) => {
  const [internalLikeCount, setInternalLikeCount] = useState()
  const [internalCurrentUserLiked, setInternalCurrentUserLiked] = useState()
  const [playAnimation, setPlayAnimation] = useState(false)
  const animationTimeout = useRef(null)

  useEffect(() => {
    if (likeCount && likeCount - 1 === internalLikeCount && currentUserLiked === 1 && !internalCurrentUserLiked) {
      setPlayAnimation(true)
      animationTimeout.current = setTimeout(() => {
        setPlayAnimation(false)
      }, 1000)
    } else if (internalCurrentUserLiked === 1 && !currentUserLiked) {
      setPlayAnimation(false)
      clearTimeout(animationTimeout.current)
    }

    if (internalLikeCount !== likeCount || internalCurrentUserLiked !== currentUserLiked) {
      setInternalLikeCount(likeCount)
      setInternalCurrentUserLiked(currentUserLiked)
    }
    return () => clearTimeout(animationTimeout.current)
  }, [likeCount, currentUserLiked])

  return (
    <HeartContainer
      style={{
        height: size(heartSize),
        width: size(heartSize),
      }}>
      {!playAnimation && 
        (currentUserLiked
          ? <PiHeartFill fill='#FF007F' size={size(heartSize)} />
          : <PiHeartBold strokeWidth={2} fill='grey' size={size(heartSize)} />
        )
      }
      {playAnimation &&
        // NOTE: at size 2, dotlottie is size 7.85. Hence how we derived the 3.925
        // NOTE: at size 2, marginBottom is size 0.25 . Hence how we derived the factor of 8
        <LottieContainer
          style={{
            height: size(heartSize*3.925),
            width: size(heartSize*3.925),
            marginBottom: size(heartSize/8),
          }}>
          <DotLottieReact
            src={heartExplosionLottie}
            loop={false}
            autoplay
            speed={7}
          />
        </LottieContainer>
      }
    </HeartContainer>
  )
}

export default Heart
